import styled, { css } from 'styled-components';
import {
  defaultColor,
  font,
  radius,
  fluidFont,
} from 'styles/theme';

export const Placeholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const Image = styled.div`
  width: 10rem;
  height: 10rem;
  border-radius: ${radius('full')};
  background-color: ${defaultColor('backgroundLight')};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    opacity: 0.2;
    width: 50%;
    // The line art follows currentColor; the "page" cutout is a literal white in the SVG, so it
    // needs its own override to keep reading as empty space instead of a bright patch.
    color: ${defaultColor('dark')};

    ${({ theme }) => theme.isDark && css`
      path:first-child {
        fill: ${defaultColor('backgroundLight')};
      }
    `}
  }
`;

export const Message = styled.p`
  color: ${defaultColor('metallic')};
  font-family: ${font('semibold')};
  ${fluidFont('16px', '18px')};
`;
